<template>
  <div
    class="w-48 h-48 bg-white rounded-md flex justify-center items-center flex-col"
  >
    <button
      @click="onRecordStop"
      class="flex justify-center items-center w-16 h-16 bg-h-info-100 rounded-full border-2 border-h-primary-500"
    >
      <v-icon
        name="hi-solid-microphone"
        class="text-primary-400 animate-pulse"
      />
    </button>
    <p class="text-h-primary-500 font-semibold mt-2">
      {{
        $t("labels.generic", {
          pt: "Gravando...",
          en: "Recording...",
        })
      }}.
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "chatRecording",
  emits: ["onRecordStop"],
  props: {
    textSize: {
      type: Boolean,
    },
    recorded: {
      type: Boolean,
    },
  },
  methods: {
    onRecordStop(): void {
      this.$emit("onRecordStop");
    },
  },
});
</script>

<style lang="scss" src="./style.scss"></style>
